var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"button-loader"},[_c('b-spinner',{staticStyle:{"width":"19px","height":"19px"},attrs:{"variant":"light","label":"Loading"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }